/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/
import { lazy, LazyExoticComponent } from 'react';
import { asMessageRenderer, type InitializeMessageRenderer, type MessageRendererType } from '@post-office/placement-common/utils/message-renderer';
/* eslint-disable @typescript-eslint/no-explicit-any */
export const rendererLoaders: Record<string, () => Promise<{ default: (props: any) => JSX.Element | null }>> = { 'message-template-template': () => import(/* webpackChunkName: "[request]" */ '@post-office/browser--post-office-template/message-template-template/placements/in-app/jira-upsell-banner/render') };
/* eslint-disable @typescript-eslint/no-explicit-any */
export const renderer: Record<string, LazyExoticComponent<(props: any) => JSX.Element | null>> = { 'message-template-template': lazy(rendererLoaders['message-template-template']!) };
const messageRenderer = asMessageRenderer(renderer, 'jira-upsell-banner');
export const initializeMessageRenderer: InitializeMessageRenderer = messageRenderer.initializeMessageRenderer;
export const MessageRenderer: MessageRendererType = messageRenderer.MessageRenderer;